<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="uploading"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin tip="上传中..." :spinning="uploading">
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">请将文件拖拽到此处上传</p>
        <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
      </a-upload-dragger>
      <!-- <a
        @click="importTemplate"
        v-hasPermi="['system:complaintOrder:importTemplate']"
        >下载模板</a
      > -->
    </a-spin>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { importComplaintOrderData } from '@/api/system/complaintOrder'
import { showImportResult, isImportSuccessCode } from '@/utils/importResult'

export default {
  name: 'ComplaintOrderImportExcel',
  data() {
    return {
      title: '投诉工单导入',
      open: false,
      fileList: [],
      uploading: false,
      updateSupport: 0,
    }
  },
  methods: {
    importExcelHandleCancel() {
      this.open = false
      this.fileList = []
      $emit(this, 'ok')
    },
    importExcelHandleOpen() {
      this.open = true
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    importExcelHandleChange() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.warning('请先选择要导入的文件', 3)
        return
      }
      const currentProjectId = this.$store.getters.currentProjectId
      if (!currentProjectId) {
        this.$message.warning('请先在右上角选择项目', 3)
        return
      }
      this.uploading = true
      const formData = new FormData()
      formData.append('file', this.fileList[0])
      formData.append('updateSupport', this.updateSupport)
      formData.append('projectId', currentProjectId)
      importComplaintOrderData(formData)
        .then((response) => {
          if (isImportSuccessCode(response.code)) {
            showImportResult(response)
            this.open = false
            this.fileList = []
            $emit(this, 'ok')
          } else {
            this.$message.error(response.message || '导入失败')
          }
        })
        .catch(() => {
          this.$message.error('导入失败，请稍后重试')
        })
        .finally(() => {
          this.uploading = false
        })
    },
    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
  },
  emits: ['ok'],
}
</script>

<style>
/* Modal 按钮样式 - 全局样式确保生效 */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

/* 取消按钮样式 */
.ant-modal-footer .ant-btn-default {
  border-radius: 4px !important;
}

/* 确定按钮样式 */
.ant-modal-footer .ant-btn-primary {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:focus:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}

.ant-modal-footer .ant-btn-primary:active:not(:disabled) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
}
</style>
